import {
  BUILDING_MODEL_TYPES,
  GENERIC_MODEL_TYPES,
  PIPELINE_MODEL_TYPES,
  ROAD_WAY_MODEL_TYPES,
} from '@App/app/configs/models.config';
import { ModelTypeConfig, totalAreaInput } from './model-type-params.types';

export const dataTypeParametersB: Record<string, ModelTypeConfig> = {
  ROADWAY: {
    subTypeName: 'roadway',
    modelTypes: ROAD_WAY_MODEL_TYPES,
    params: [
      {
        title: 'Length',
        formControlName: 'length',
        inputType: 'number',
      },
      {
        title: 'Total width',
        formControlName: 'totalWidth',
        inputType: 'number',
      },
      {
        title: 'Paved width',
        formControlName: 'pavedWidth',
        inputType: 'number',
      },
      {
        title: 'Traffic lines',
        formControlName: 'trafficLines',
        inputType: 'number',
      },
      {
        title: 'Lights distance',
        formControlName: 'lightsDistance',
        inputType: 'number',
      },
    ],
    types: {
      HIGHWAY: 'highway',
      PRIMARY: 'primary',
      SECONDARY: 'secondary',
      TERTIARY: 'tertiary',
      RESIDENTIAL: 'residential',
    },
  },

  PIPELINE: {
    subTypeName: 'pipeline',
    modelTypes: PIPELINE_MODEL_TYPES,
    params: [
      {
        title: 'Total length',
        formControlName: 'totalLength',
        inputType: 'number',
      },
      {
        title: 'Section length',
        formControlName: 'sectionLength',
        inputType: 'number',
      },
      {
        title: 'Diameter',
        formControlName: 'diameter',
        inputType: 'number',
      },
      {
        title: 'Wall thickness',
        formControlName: 'wallThickness',
        inputType: 'number',
      },
      {
        title: 'Steel grade',
        formControlName: 'steelGrade',
        inputType: 'number',
      },
      {
        title: 'Pressure',
        formControlName: 'pressure',
        inputType: 'number',
      },
    ],
    types: {
      OIL: 'oil',
      GAS: 'gas',
      WATER: 'water',
    },
  },
  BUILDING: {
    subTypeName: 'building',
    modelTypes: BUILDING_MODEL_TYPES,
    params: [
      {
        title: 'Total height',
        formControlName: 'totalHeight',
        inputType: 'number',
      },
      {
        title: 'Total floors',
        formControlName: 'totalFloors',
        inputType: 'number',
      },
      totalAreaInput(),
    ],
    types: {
      RESIDENTIAL: 'residential',
      COMMERCIAL: 'commercial',
      INDUSTRIAL: 'industrial',
      PUBLIC: 'public',
    },
  },

  GENERIC: {
    subTypeName: 'generic',
    modelTypes: GENERIC_MODEL_TYPES,
    params: [
      totalAreaInput(),
      {
        title: 'Length',
        formControlName: 'length',
        inputType: 'number',
      },
      {
        title: 'Width',
        formControlName: 'width',
        inputType: 'number',
      },
      {
        title: 'Height',
        formControlName: 'height',
        inputType: 'number',
      },
    ],
    types: {
      GENERIC: 'generic',
    },
  },
};
